import { IconProps } from './icon';
import { ICON_LOOKUP } from './lookup';

export const isValidIcon = (icon?: unknown): icon is IconProps['icon'] => {
  return typeof icon === 'string' && icon in ICON_LOOKUP;
};
